import { render, staticRenderFns } from "./LessonFormDialog.vue?vue&type=template&id=0be45e63&scoped=true"
import script from "./LessonFormDialog.vue?vue&type=script&lang=js"
export * from "./LessonFormDialog.vue?vue&type=script&lang=js"
import style0 from "./LessonFormDialog.vue?vue&type=style&index=0&id=0be45e63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be45e63",
  null
  
)

export default component.exports